
/*
 *
 * ┌────────────────────────────────────────────────────────────────┐
 * │                                                                │
 * │                       ____                __                   │
 * │                      / __ \___  ___  ____/ /                   │
 * │                     / /_/ / _ \/ _ \/ __  /                    │
 * │                    / _, _/  __/  __/ /_/ /                     │
 * │                   /_/ |_|\___/\___/\__,_/                      │
 * │                                                                │
 * │                                                                │
 * └────────────────────────────────────────────────────────────────┘
 *
 */




/*-----------------------------------------------------------------------------------*/
/*  00. COMPONENTS IMPORTS
/*-----------------------------------------------------------------------------------*/

import gsap from 'gsap'
import { CSSPlugin } from 'gsap/all'
import Vue from 'vue'
import FormPolyfill from 'form-association-polyfill/with-shims'


import VueApp from './App.vue'
import Browser from './components/Browser'
import Layout from './components/Layout'


gsap.registerPlugin(CSSPlugin)
FormPolyfill.register()

const APP = window.APP || {}




/*-----------------------------------------------------------------------------------*/
/*  01. INIT
/*-----------------------------------------------------------------------------------*/

const initApp = () => {
    window.APP = APP

    APP.Browser = new Browser()
    APP.Layout  = new Layout()
}

if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    initApp()
} else {
    document.addEventListener('DOMContentLoaded', initApp)
}

new Vue(VueApp) // eslint-disable-line no-new

